import withRedux from "../../withRedux";
import { RootState } from "../../reducers";

const UnreadCount = ({ unreadConversationsCount }) => {
	return unreadConversationsCount ? ` (${unreadConversationsCount})` : null;
};

const mapStateToProps = ({ chat: { unreadConversationsCount } }: RootState) => {
	return { unreadConversationsCount };
};

export default withRedux({}, mapStateToProps)(UnreadCount);
